module.exports = __webpack_public_path__ + "img/XWBD.0cd8f7db.png";